module.exports = __webpack_public_path__ + "img/p2-96.83216a52.png";